import { useState, useEffect, useRef } from "react";
import api from './../../../Axios.js';
import { toast } from 'react-toastify';
import { toastConfirm } from '../../../utils/toastConfirm.jsx';
import * as XLSX from 'xlsx';
import { FaSpinner, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { defaultDateFormatter, modalStyle, modalContentStyle } from "../../../Helper/functionHelper.js";
import useAuthUser from "../../../hooks/useAuthUser.js";
import CarouselImage from "../../../utils/carousel-image.jsx";
import { CustomSelect } from "../../../Helper/functionHelper.js";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { parseISO, format } from "date-fns";
import { TextField } from "@mui/material";
import ImportAssignment from "../../../components/asset-management/ImportAssignemt.jsx";

const AssetTab = () => {

    const [declaration, setDeclaration] = useState('');
    const [actionDeclaration, setActionDeclaration] = useState('');
    const [enableButton, setEnableButton] = useState(true);
    const fetchDeclaration = async () => {
        try {
            const res = await api.get('/declaration');
            setDeclaration(res.data.data?.declaration || '');
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        fetchDeclaration();
    }, []);
    const checkboxChange = (e) => {
        if (e.target.checked) {
            setEnableButton(true);
        } else {
            setEnableButton(false);
        }
    };


    const { loggedInUser } = useAuthUser();
    const userRole = Number(loggedInUser?.role);

    const [assets, setAssets] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [assetTypes, setAssetTypes] = useState([]);
    const [assetMakers, setAssetMakers] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [managers, setManagers] = useState([]);
    const [assignModalShow, setAssignModalShow] = useState(false);
    const [assignModalForm, setAssignModalForm] = useState({
        asset_id: null,
        user_id: null,
        remark: null,
        request_type: '', // New, Return
    });


    const [ActionVisible, setActionVisible] = useState(false);
    const [actionTitle, setActionTitle] = useState('');
    const [ActionData, setActionData] = useState(null);
    const [actionFormData, setActionFormData] = useState({
        _id: null,
        status: '',
        remark: '',
    });
    useEffect(() => {
        if (ActionData) {
            setActionFormData({
                _id: ActionData?._id || null,
                status: ActionData?.status || 0,
                remark: ActionData?.remark || '',
            });
            setActionVisible(true);
        }
    }, [ActionData]);

    const handleChangeAction = (e) => {
        const { name, value } = e.target;
        setErrorsForm({ ...errorsForm, [name]: '' });

        setActionFormData((prevData) => {
            let updatedData = { ...prevData, [name]: value };
            // Conditionally clear other fields based on request_type
            return updatedData;
        });
    };
    const [isAssigning, setIsAssigning] = useState(false);
    const handleActionSave = async (e) => {
        e.preventDefault();

        if (isAssigning) return; // prevent multiple clicks

        try {
            setIsAssigning(true);
            // validate errors here
            const newErrors = {};
            if (!actionFormData.remark?.trim()) {
                newErrors.remark = 'Remark is required';
            }
            setErrorsForm(newErrors);
            if (Object.keys(newErrors).length === 0) {
                const result = await api.post(`/assets/remark`, actionFormData);
                toast.success(result?.data?.message || 'Remark updated!');
                setActionVisible(false);
                fetchAssets();
            }
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsAssigning(false);
        }
    };


    const [assetFormData, setAssetFormData] = useState({
        asset_type: '',
        asset_maker: '',
        asset_name: '',
        sr_no: '',
        description: '',
        purchase_date: '',
        warranty: '',
        status: 1,
        photos: [],
        _id: null,
    });

    const [filteredAssets, setFilteredAssets] = useState([]);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterForm, setFilterForm] = useState({
        asset_type: '',
        asset_maker: '',
        search_input: '',
        department: '',
        rep_manager: '',
        status: '',
        assigned_status: ''
    });

    const handleChangeFilter = (e) => {
        const { name, value } = e.target;
        setFilterForm({ ...filterForm, [name]: value });
    };

    useEffect(() => {
        const result = assets.filter(item => {
            const assetTypeId = item.asset_type?._id || '';
            const assetMakerId = item.asset_maker?._id || '';
            const asset_sr_no = item.sr_no || '';
            const search_fields = item?.asset_name + item?.sr_no + item?.description + item.assigned_to?._FirstName + item.assigned_to?._MiddleName + item.assigned_to?._LastName + item.assigned_to?._UserEmployeeID || '';

            const department = item.assigned_to?._UserDepartment || '';
            const rep_manager = item.assigned_to?._ReportingManager || '';
            const status = item.status ?? '';
            const assigned_status = item.assigned_to ?? '';

            const matchesAssetType = !filterForm.asset_type || assetTypeId === filterForm.asset_type;
            const matchesAssetMaker = !filterForm.asset_maker || assetMakerId === filterForm.asset_maker;

            const matchesSearched = !filterForm.search_input || search_fields.toLowerCase().includes(filterForm.search_input.toLowerCase());

            const matchesDepartment = !filterForm.department || department === Number(filterForm.department);
            const matchesRepManager = !filterForm.rep_manager || rep_manager === Number(filterForm.rep_manager);

            const matchesStatus = filterForm.status === '' || status === Number(filterForm.status);

            const matchesAssignment =
                filterForm.assigned_status === '' || // no filter applied
                (filterForm.assigned_status === '1' && item.assigned_to) || // assigned
                (filterForm.assigned_status === '0' && !item.assigned_to); // not assigned


            return matchesAssetType && matchesAssetMaker && matchesSearched && matchesDepartment && matchesRepManager && matchesStatus && matchesAssignment;
        });

        setFilteredAssets(result);
    }, [filterForm, assets]);


    useEffect(() => {
        fetchAssets();
        fetchAssetTypes();
        fetchAssetMakers();
        fetchDepartments({ _DeptStatus: 1 });
        fetchUsers({ _UserStatus: 1 });
    }, []);
    useEffect(() => {
        setCurrentPage(1);
    }, [filterForm, itemsPerPage]);

    useEffect(() => {
        if (modalData) {
            setAssetFormData({
                asset_type: modalData.asset_type?._id || '',
                asset_maker: modalData.asset_maker?._id || '',
                asset_name: modalData.asset_name || '',
                sr_no: modalData.sr_no || '',
                description: modalData.description || '',
                purchase_date: modalData.purchase_date || '',
                warranty: modalData.warranty || '',
                status: modalData.status ?? 1,
                _id: modalData._id || null,
            });
            setModalVisible(true);
        }
    }, [modalData]);

    const fetchAssets = async () => {
        try {
            const res = await api.get('/assets');
            setAssets(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchAssetTypes = async () => {
        try {
            const res = await api.get('/asset-types');
            setAssetTypes(res.data.data);
        } catch (err) {
            console.error(err)
        }
    }
    const fetchAssetMakers = async () => {
        try {
            const res = await api.get('/asset-makers');
            setAssetMakers(res.data.data);
        } catch (err) {
            console.error(err)
        }
    }

    const fetchDepartments = async (params) => {
        try {
            const res = await api.get('/departments', { params: params });
            setDepartments(res.data.data);
        } catch (err) {
            console.error(err)
        }
    }
    const fetchUsers = async (params) => {
        try {
            const res = await api.get('/users', { params: params });
            setUsers(res.data.data);

            // fetch managers
            let ress = '';
            if ([1, 2, 8, 9].includes(userRole)) { // if admin or IT Admin
                ress = await api.get('/users/get-reporting-managers', { params: params });
            } else {
                ress = await api.get('/users/my-reportee-managers');
            }
            setManagers(ress.data.data);
        } catch (err) {
            console.error(err)
        }
    }

    const deleteAsset = (_id) => {
        toastConfirm({
            message: "Do you really want to delete this asset?",
            onConfirm: async () => {
                try {
                    await api.delete(`/assets/${_id}`);
                    toast.success("Asset deleted successfully!");
                    fetchAssets();
                } catch (err) {
                    // toast.error("Failed to delete!");
                    toast.error(err?.response?.data?.details || err.message);
                }
            },
        });
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredAssets.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredAssets.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const exportToExcel = () => {
        const exportData = filteredAssets.map(item => ({
            "Asset Name": item.asset_name,
            "Asset Type": item.asset_type.type_name,
            "Asset Maker": item.asset_maker.maker_name,
            "Sr. No.": item.sr_no,
            "Assigned to": [
                item.assigned_to ? item.assigned_to._FirstName : '-',
                item.assigned_to?._MiddleName,
                item.assigned_to?._LastName
            ]
                .filter(Boolean)
                .join(' ') +
                (item.assigned_to?._UserEmployeeID ? ` (${item.assigned_to._UserEmployeeID})` : ''),

            "Description": item.description,
            "Purchase Date": item.purchase_date ? defaultDateFormatter(item.purchase_date) : '-',
            "Warranty Date": item.warranty ? defaultDateFormatter(item.warranty) : '-',
            "Status": item.status ? 'Active' : 'In-Active',
            "Created By": item.created_by_name,
            "Created At": defaultDateFormatter(item.created_at),
            "Updated By": item.updated_by_name,
            "Updated At": defaultDateFormatter(item.updated_at),
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

        XLSX.writeFile(workbook, `Assets Exported - ${new Date().toLocaleDateString()}.xlsx`);
    };

    const [errorsForm, setErrorsForm] = useState({});
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setErrorsForm({ ...errorsForm, [name]: '' });
        if (name === "photos") {
            setAssetFormData({ ...assetFormData, photos: Array.from(files) });
        } else {
            setAssetFormData({ ...assetFormData, [name]: value });
        }
    };

    const [errorsAssignForm, setErrorsAssignForm] = useState({});
    const handleAssignChange = (e) => {
        const { name, value } = e.target;
        setErrorsAssignForm({ ...errorsAssignForm, [name]: '' });
        setAssignModalForm({ ...assignModalForm, [name]: value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {

            // validate errors here
            const newErrors = {};
            if (!assetFormData.asset_type) newErrors.asset_type = 'Asset Type is required';
            if (!assetFormData.asset_name?.trim()) newErrors.asset_name = 'Asset Name is required';
            // if (!assetFormData.sr_no?.trim()) newErrors.sr_no = 'Serial Number is required';
            if (!assetFormData.asset_maker) newErrors.asset_maker = 'Maker is required';
            if (!assetFormData.status?.toString()) newErrors.status = 'Status is required';
            setErrorsForm(newErrors);


            if (Object.keys(newErrors).length === 0) {
                const formData = new FormData();

                // Append text fields
                for (let key in assetFormData) {
                    if (key !== 'photos') {
                        formData.append(key, assetFormData[key]);
                    }
                }

                // Append multiple files
                if (assetFormData.photos?.length) {
                    assetFormData.photos.forEach((file, index) => {
                        formData.append('photos', file); // backend should accept `photos` as array
                    });
                }

                if (assetFormData._id) {
                    await api.patch(`/assets/${assetFormData._id}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    toast.success("Asset updated!");
                } else {
                    await api.post(`/assets`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    toast.success("Asset created!");
                }

                setModalVisible(false);
                fetchAssets();
            }
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };










    // for import data
    const [showImportBox, setShowImportBox] = useState(false);
    const [importBtnLabel, setImportBtnLabel] = useState('Import valid data');
    const fileInputRef = useRef(null);
    const importBoxRef = useRef(null);
    const importButtonRef = useRef(null);
    const [excelData, setExcelData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const handleImportClick = () => {
        setShowImportBox((prev) => !prev);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false, dateNF: "yyyy-mm-dd" });

            const [validData, validationErrors] = validateData(jsonData);
            setExcelData(validData);
            setErrors(validationErrors);
            setShowModal(true);

            // hide import popups
            setShowImportBox((prev) => !prev);

        };

        reader.readAsBinaryString(file);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                importBoxRef.current &&
                !importBoxRef.current.contains(event.target) &&
                importButtonRef.current &&
                !importButtonRef.current.contains(event.target)
            ) {
                setShowImportBox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const validateData = (data) => {

        const errors = [];

        const validData = data.map((row, index) => {
            const rowErrors = {};

            // 🔹 Validate Asset Type
            if (!row.asset_type) {
                rowErrors.asset_type = "Asset type is required";
            } else {
                const matchedType = assetTypes.find(
                    (type) => type.type_name?.trim().toLowerCase() === row.asset_type.trim().toLowerCase()
                );

                if (!matchedType) {
                    rowErrors.asset_type = "Asset type doesn't exist";
                } else if (matchedType.status === 0) {
                    rowErrors.asset_type = "Asset type is inactive";
                }
            }

            // 🔹 Validate Asset Maker
            if (!row.asset_maker) {
                rowErrors.asset_maker = "Asset maker is required";
            } else {
                const matchedMaker = assetMakers.find(
                    (maker) => maker.maker_name?.trim().toLowerCase() === row.asset_maker.trim().toLowerCase()
                );

                if (!matchedMaker) {
                    rowErrors.asset_maker = "Asset maker doesn't exist";
                } else if (matchedMaker.status === 0) {
                    rowErrors.asset_maker = "Asset maker is inactive";
                }
            }

            // 🔹 Validate Asset Name
            if (!row.asset_name) rowErrors.asset_name = "Asset name is required";

            // 🔹 Validate Sr. No.
            // if (!row.sr_no) rowErrors.sr_no = "Sr.No. is required";

            // check here in assets also
            assets.forEach((asset) => {
                if (asset.sr_no === row.sr_no) {
                    rowErrors.sr_no = "Sr.No. already exists";
                }
            });

            // 🔹 Validate Purchase Date
            if (row.purchase_date) {
                const parsedDate = new Date(row.purchase_date);
                if (isNaN(parsedDate.getTime())) {
                    rowErrors.purchase_date = "Invalid purchase date";
                }
            }

            // 🔹 Validate Warranty Date
            if (row.warranty) {
                const parsedDate = new Date(row.warranty);
                if (isNaN(parsedDate.getTime())) {
                    rowErrors.warranty = "Invalid warranty date";
                }
            }

            // 🔹 Validate Status
            if (row.status && !['active', 'in-active'].includes(row.status.trim().toLowerCase())) {
                rowErrors.status = "Invalid status";
            }

            // 🔹 Push errors if any for this row
            if (Object.keys(rowErrors).length > 0) {
                errors.push({ row: index + 2, errors: rowErrors }); // Excel rows usually start at 2
            }

            return row;
        });

        return [data, errors];
    };



    const handleImport = async () => {
        try {
            setImportBtnLabel(<FaSpinner />);
            // const validRows = excelData.filter((_, i) => !errors.some(e => e.row === i + 2));

            // if(validRows) {
            //     toast.error('No valid data found', {
            //         position: "top-right",
            //         autoClose: 3000,
            //     });
            // }

            const result = await api.post(`/assets/import`, excelData, {
                headers: { 'Content-Type': 'application/json' }
            });
            setShowModal(false);
            setImportBtnLabel('Import valid data');
            toast.success(result.data.message);
            fetchAssets();
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    const handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_BUILD_PATH}/uploads/sample_asset_import.xlsx`;
        link.download = 'sample_asset_import.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [showModalAssignee, setShowModalAssignee] = useState(false);
    const [assignees, setAssignees] = useState([]);

    useEffect(() => {
        if (showModalAssignee) {
            fetchAssetDetails();
        }
    }, [showModalAssignee]);

    const fetchAssetDetails = async () => {
        try {
            const res = await api.get(`/assets/${showModalAssignee}`);
            setAssignees(res.data.data.assigned);
        } catch (err) {
            console.error(err);
        }
    }

    const handleAssignClicked = async (e) => {
        e.preventDefault();

        if (isAssigning) return; // prevent multiple clicks

        try {
            setIsAssigning(true);

            // validate errors here
            const newErrors = {};

            if (!assignModalForm.asset_id) newErrors.asset_id = 'Asset is required';
            if (!assignModalForm.user_id) newErrors.user_id = 'User is required';
            if (!assignModalForm.request_type) newErrors.request_type = 'Request type is required';

            // Only require remark if request_type is "Return"
            if (
                assignModalForm.request_type === "Return" &&
                !assignModalForm.remark?.trim()
            ) {
                newErrors.remark = 'Remark is required';
            }

            setErrorsAssignForm(newErrors);


            // console.log(assignModalForm);


            if (Object.keys(newErrors).length === 0) {

                const result = await api.post(`/assets/assignment`, assignModalForm);
                toast.success(result?.data?.message || "Assignment updated!");

                setAssignModalShow(false);
                fetchAssets();
            }
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsAssigning(false);
        }
    }

    const [assignmentLables, setAssignmentLables] = useState({
        labelTitle: 'Assign Asset',
        labelUser: 'Assign to*',
        userDisabled: false
    })

    useEffect(() => {
        if (assignModalForm.request_type === 'Return') {
            setAssignmentLables({
                labelTitle: 'Return Asset',
                labelUser: 'Return From*',
                userDisabled: true
            });
        } else {
            setAssignmentLables({
                labelTitle: 'Assign Asset',
                labelUser: 'Assign to*',
                userDisabled: false
            });
        }
    }, [assignModalForm]);

    return (
        <div>

            {modalVisible && (
                <div className="modal show d-block fade" tabIndex="-1" role="dialog" style={modalStyle} onClick={() => setModalVisible(false)}>
                    <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{assetFormData._id ? 'Edit Asset' : 'Add Asset'}</h5>
                                <button title="Close" type="button" className="btn-close" onClick={() => setModalVisible(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="popup-form">
                                    <div className="popup-form-row form-row-full">
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Asset Type*</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="asset_type"
                                                        value={assetFormData.asset_type}
                                                        options={[
                                                            { value: '', label: '-- Select --' },
                                                            ...assetTypes
                                                                .filter(type => type.status === 1) // ✅ only active ones
                                                                .map(type => ({
                                                                    value: type._id,
                                                                    label: type.type_name
                                                                }))
                                                        ]}
                                                        onChange={handleChange}
                                                    />
                                                    {errorsForm.asset_type && <div className="text-danger">{errorsForm.asset_type}</div>}
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Asset Name*</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="asset_name" value={assetFormData.asset_name} onChange={handleChange}
                                                        className="form-control" placeholder="Asset name" required />
                                                    {errorsForm.asset_name && <div className="text-danger">{errorsForm.asset_name}</div>}
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Serial Number</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="sr_no" value={assetFormData.sr_no} onChange={handleChange}
                                                        className="form-control" placeholder="Sr No." />
                                                    {errorsForm.sr_no && <div className="text-danger">{errorsForm.sr_no}</div>}
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Maker*</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="asset_maker"
                                                        value={assetFormData.asset_maker}
                                                        options={[
                                                            { value: '', label: '-- Select --' },
                                                            ...assetMakers
                                                                .filter(maker => maker.status === 1) // ✅ only active makers
                                                                .map(maker => ({
                                                                    value: maker._id,
                                                                    label: maker.maker_name
                                                                }))
                                                        ]}
                                                        onChange={handleChange}
                                                    />
                                                    {errorsForm.asset_maker && <div className="text-danger">{errorsForm.asset_maker}</div>}
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Description</div>
                                                <div className="form-info-content">
                                                    <textarea name="description" className="form-control" placeholder="Description" value={assetFormData.description} onChange={handleChange}></textarea>
                                                </div>
                                            </div>

                                            <div className="form-info">
                                                <div className="form-info-label">Photos</div>
                                                <div className="form-info-content">
                                                    <input type="file" name="photos" className="form-control" onChange={handleChange} multiple accept="image/jpeg, image/png, image/jpg" />
                                                </div>
                                                <div className="filetypes">
                                                    File Type: JPG, JPEG, PNG &nbsp; Max Size: 4MB
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Date of Purchase</div>
                                                <div className="form-info-content">

                                                    <DatePicker
                                                        label="Select Date"
                                                        onChange={(date) =>
                                                            setAssetFormData({
                                                                ...assetFormData,
                                                                // Format as YYYY-MM-DD in local time
                                                                purchase_date: date ? format(date, "yyyy-MM-dd") : "",
                                                            })
                                                        }
                                                        value={
                                                            assetFormData.purchase_date
                                                                ? parseISO(assetFormData.purchase_date)
                                                                : null
                                                        }
                                                        format="dd MMM yyyy" // visible in field
                                                        slotProps={{
                                                            textField: {
                                                                variant: "standard",
                                                                fullWidth: true,
                                                            },
                                                            popper: {
                                                                placement: "top-end",
                                                                modifiers: [
                                                                    {
                                                                        name: 'offset',
                                                                        options: {
                                                                            offset: [0, 8],
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-info">
                                                <div className="form-info-label">Warranty Date</div>
                                                <div className="form-info-content">

                                                    <DatePicker
                                                        label="Select Date"
                                                        onChange={(date) =>
                                                            setAssetFormData({
                                                                ...assetFormData,
                                                                // Format as YYYY-MM-DD in local time
                                                                warranty: date ? format(date, "yyyy-MM-dd") : "",
                                                            })
                                                        }
                                                        value={
                                                            assetFormData.warranty
                                                                ? parseISO(assetFormData.warranty)
                                                                : null
                                                        }
                                                        format="dd MMM yyyy" // visible in field
                                                        slotProps={{
                                                            textField: {
                                                                variant: "standard",
                                                                fullWidth: true,
                                                            },
                                                            popper: {
                                                                placement: "top-end",
                                                                modifiers: [
                                                                    {
                                                                        name: 'offset',
                                                                        options: {
                                                                            offset: [0, 8],
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        }}
                                                    />

                                                </div>
                                            </div>

                                            <div className="form-info">
                                                <div className="form-info-label">Status*</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="status"
                                                        value={assetFormData.status}
                                                        options={[
                                                            { value: 1, label: 'Active' },
                                                            { value: 0, label: 'In-Active' },
                                                        ]}
                                                        onChange={handleChange}
                                                    />
                                                    {errorsForm.status && <div className="text-danger">{errorsForm.status}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-btn-flex">
                                                <button type="button" className="btn btn-success"
                                                    onClick={handleSave}>Save</button>
                                                <button type="button" className="btn btn-secondary" onClick={() => {
                                                    setModalVisible(false);
                                                    setModalData(null);
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {/* import modal */}
            {showModal && (
                <div style={modalStyle}>
                    <div style={modalContentStyle}>
                        <h4>Preview Excel Data</h4>
                        <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Asset Type</th>
                                        <th>Asset Maker</th>
                                        <th>Asset Name</th>
                                        <th>Sr.No.</th>
                                        <th>Description</th>
                                        <th>Purchase Date</th>
                                        <th>Warranty Date</th>
                                        <th>Status</th>
                                        <th>Errors</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelData.map((row, idx) => {
                                        const rowError = errors.find(e => e.row === idx + 2);
                                        return (
                                            <tr key={idx} style={{ backgroundColor: rowError ? '#fdd' : '#dfd' }}>
                                                <td>{row.asset_type}</td>
                                                <td>{row.asset_maker}</td>
                                                <td>{row.asset_name}</td>
                                                <td>{row.sr_no}</td>
                                                <td>{row.description}</td>
                                                <td>{row.purchase_date}</td>
                                                <td>{row.warranty_date}</td>
                                                <td>{row.status}</td>
                                                <td style={{ color: 'red' }}>{rowError ? Object.values(rowError.errors).join(', ') : ''}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 d-flex justify-content-end">
                            <button className="btn btn-success btn-sm me-2" onClick={handleImport}>{importBtnLabel}</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {/* assignee modal */}
            {showModalAssignee && (
                <div className="modal show d-block fade" tabIndex="-1" role="dialog" style={modalStyle} onClick={() => setShowModalAssignee(false)}>
                    <div className="modal-dialog modal-xl" role="document"  onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assigned on</h5>
                                <button data-bs-toggle="tooltip" data-bs-placement="right" title="Close"
                                    type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => setShowModalAssignee(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table tbl-main" cellPadding="0" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <th>Employee Name</th>
                                                <th>Assigned Date</th>
                                                <th>Return Date</th>
                                                <th>Assigned Remark</th>
                                                <th>Return Remark</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assignees.length > 0 ?
                                                assignees.map((assignee, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {assignee?.user_id_encrypted ? (
                                                                <a
                                                                    href={`../../employee/profile/${assignee.user_id_encrypted}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {assignee.assigned_to}
                                                                </a>
                                                            ) : (
                                                                <span>-</span>
                                                            )}

                                                        </td>
                                                        <td>{defaultDateFormatter(assignee.assigned_date)}</td>
                                                        <td>{assignee.return_date ? defaultDateFormatter(assignee.return_date) : <span>-</span>}</td>
                                                        <td>{assignee.assigned_remark}</td>
                                                        <td>{assignee.return_remark}</td>
                                                    </tr>
                                                ))
                                                : <tr><td colspan='5'>No records found</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* assign asset modal */}
            {assignModalShow && (
                <div className="modal show d-block fade" tabIndex="-1" role="dialog" style={modalStyle} onClick={() => setAssignModalShow(false)}>
                    <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> {assignmentLables.labelTitle} </h5>
                                <button data-bs-toggle="tooltip" data-bs-placement="right" title="Close"
                                    type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => setAssignModalShow(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="popup-form">
                                    <div className="popup-form-row form-row-full">
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label"> {assignmentLables.labelUser}</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="user_id"
                                                        value={assignModalForm.user_id}
                                                        options={[
                                                            { value: '', label: '-- Select --' },
                                                            ...users.map(user => ({
                                                                value: user._UserID,
                                                                label: [
                                                                    user._FirstName,
                                                                    user._MiddleName,
                                                                    user._LastName
                                                                ]
                                                                    .filter(Boolean)
                                                                    .join(' ') + ' (' + user._UserEmployeeID + ')'
                                                            }))
                                                        ]}
                                                        onChange={handleAssignChange}
                                                        disabled={assignmentLables.userDisabled}
                                                    />
                                                    {errorsAssignForm.user_id && <div className="text-danger">{errorsAssignForm.user_id}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Remark</div>
                                                <div className="form-info-content">
                                                    <textarea name="remark" className="form-control" onChange={handleAssignChange} value={assignModalForm.remark}></textarea>
                                                    {errorsAssignForm.remark && <div className="text-danger">{errorsAssignForm.remark}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-btn-flex">
                                                <button className="btn btn-success"
                                                    onClick={handleAssignClicked} disabled={isAssigning}>
                                                    {isAssigning ? 'Saving...' : 'Save'}
                                                </button>
                                                <button className="btn btn-secondary" onClick={() => setAssignModalShow(false)}>Cancel</button>
                                            </div>
                                            {/* asset_id: '',
                                            request_type: '', // Return, New */}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* Acknowledge/Reject Modal */}
            {ActionVisible && (
                <div className="modal show d-block fade" tabIndex="-1" role="dialog" style={modalStyle} onClick={() => setActionVisible(false)}>
                    <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{actionTitle}</h5>
                                <button type="button" className="btn-close" onClick={() => setActionVisible(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="popup-form">
                                    <div className="popup-form-row form-row-full">
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Remark</div>
                                                <div className="form-info-content">
                                                    <textarea name="remark" className="form-control" placeholder="Remark" value={actionFormData.remark} onChange={handleChangeAction}></textarea>
                                                    {errorsForm.remark && <div className="text-danger">{errorsForm.remark}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {actionDeclaration && (
                                                <div className="alert alert-warning" style={{ whiteSpace: 'pre-line' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: actionDeclaration }} />
                                                    <input type="checkbox" onChange={checkboxChange} /> <b><i>I hereby declare that I have read and understood the above statement.</i></b>
                                                </div>
                                            )}
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-btn-flex">
                                                <button type="button" className="btn btn-success"
                                                    onClick={handleActionSave} disabled={isAssigning || !enableButton}>
                                                    {isAssigning ? 'Saving...' : 'Save'}
                                                </button>
                                                <button type="button" className="btn btn-secondary" onClick={() => {
                                                    setActionVisible(false);
                                                    setActionData(null);
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}




            <div className="content-block">
                <div className="filter-toolbar mt-0" id="filter">
                    <div className="row">

                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                            <div className="filter-toolbar-item">
                                <CustomSelect
                                    name="asset_type"
                                    value={filterForm.asset_type}
                                    options={[
                                        { value: '', label: '-- Asset type --' },
                                        ...assetTypes.map(type => ({
                                            value: type._id,
                                            label: type.type_name
                                        }))
                                    ]}
                                    onChange={handleChangeFilter}
                                />
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                            <div className="filter-toolbar-item">
                                <CustomSelect
                                    name="asset_maker"
                                    value={filterForm.asset_maker}
                                    options={[
                                        { value: '', label: '-- Asset maker --' },
                                        ...assetMakers.map(maker => ({
                                            value: maker._id,
                                            label: maker.maker_name
                                        }))
                                    ]}
                                    onChange={handleChangeFilter}
                                />
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                            <div className="filter-toolbar-item">
                                <TextField
                                    name="search_input"
                                    label="Emp Name/Code, Asset name, Sr No."
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    onChange={handleChangeFilter}
                                    value={filterForm.search_input}
                                />
                            </div>
                        </div>
                        {userRole !== 7 && (    // hide from employee
                            <>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                    <div className="filter-toolbar-item">
                                        <CustomSelect
                                            name="status"
                                            value={filterForm.status}
                                            options={[
                                                { value: '', label: 'All' },
                                                { value: 1, label: 'Active' },
                                                { value: 0, label: 'In-Active' },
                                            ]}
                                            onChange={handleChangeFilter}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                    <div className="filter-toolbar-item">
                                        <CustomSelect
                                            name="assigned_status"
                                            value={filterForm.assigned_status}
                                            options={[
                                                { value: '', label: 'Assignment Status' },
                                                { value: '1', label: 'Assigned' },
                                                { value: '0', label: 'Un-Assigned' },
                                            ]}
                                            onChange={handleChangeFilter}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                                    <div className="filter-toolbar-item">
                                        <CustomSelect
                                            name="department"
                                            value={filterForm.department}
                                            options={[
                                                { value: '', label: '-- Department --' },
                                                ...departments.map(department => ({
                                                    value: department._DeptID,
                                                    label: department._DeptName
                                                }))
                                            ]}
                                            onChange={handleChangeFilter}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                    <div className="filter-toolbar-item">
                                        <CustomSelect
                                            name="rep_manager"
                                            value={filterForm.rep_manager}
                                            options={[
                                                { value: '', label: '-- Reporting Manager --' },
                                                ...managers.map(manager => ({
                                                    value: manager._UserID,
                                                    label: [
                                                        manager._FirstName,
                                                        manager._MiddleName,
                                                        manager._LastName
                                                    ]
                                                        .filter(Boolean)
                                                        .join(' ') + ' (' + manager._UserEmployeeID + ')'
                                                }))
                                            ]}
                                            onChange={handleChangeFilter}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-12">
                        <h2>
                            Assets

                            <span className="edit float-end has-export">


                                {[1, 2, 8, 9].includes(userRole) && (
                                    <span className="toggle-wrapper">
                                        <button
                                            type="button"
                                            id="importEmployees"
                                            className="btn btn-dark btn-sm"
                                            onClick={handleImportClick}
                                            ref={importButtonRef}
                                        >
                                            <span className="material-icons-outlined">file_download</span>
                                            <span className="text"> Import</span>
                                        </button>
                                        {showImportBox && (
                                            <div className="import-container me-2" style={{ "display": "block" }}>
                                                <div
                                                    className="import-box import-section arrow-top"
                                                    ref={importBoxRef}
                                                    style={{ "display": "block" }}>
                                                    <div className="upload-box" onClick={() => fileInputRef.current.click()}>
                                                        <h3 id="fileTrigger">
                                                            <span className="material-icons-outlined">file_download</span> Click here to import
                                                        </h3>
                                                        <div className="supported-files">Supported types: .xls and .csv</div>
                                                    </div>

                                                    <div className="form-info-content mt-3">
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            accept=".xlsx, .xls"
                                                            ref={fileInputRef}
                                                            onClick={() => { fileInputRef.current.value = null; }}
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <button
                                                            className="btn btn-success mt-2"
                                                            onClick={handleDownloadSample}
                                                            rel="noopener noreferrer"
                                                        >
                                                            Download Excel Format
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </span>
                                )}
                                {[1, 2, 8, 9].includes(userRole) && (
                                    <ImportAssignment assetsFun={fetchAssets} assets={assets} employees={users} />
                                )}


                                {/* Export button */}
                                <button
                                    onClick={exportToExcel}
                                    className="btn btn-success btn-sm ms-2"
                                    disabled={filteredAssets.length === 0}
                                    style={{
                                        padding: "4px 12px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        display: "inline-flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span
                                        className="icon"
                                        style={{
                                            fontSize: "15px",
                                            marginRight: "4px",
                                            position: "relative",
                                            top: "-1px",
                                        }}
                                    >
                                        <img
                                            src={`${process.env.REACT_APP_PUBLIC_PATH}/images/icons/icon-export.svg`}
                                            style={{ height: "18px" }}
                                            alt="Export"
                                        />
                                    </span>
                                    <span className="text">Export</span>
                                </button>

                                {/* Add New Button */}
                                {[1, 2, 8, 9].includes(userRole) && (
                                    <button title="Add New" className="btn add ms-2" onClick={() => { setModalData({}); setErrorsForm({}); }}>
                                        <span className="material-icons-outlined">add_box</span>
                                    </button>
                                )}



                            </span>

                        </h2>
                    </div>
                </div>

                {/* Filters */}
                <div className="row">
                    <div className="col-sm-2">
                        <label>Items per page:</label>
                        <select className='form-control' onChange={(e) => setItemsPerPage(parseInt(e.target.value))}>
                            <option value="5" selected={itemsPerPage === 5}>5</option>
                            <option value="10" selected={itemsPerPage === 10}>10</option>
                            <option value="25" selected={itemsPerPage === 25}>25</option>
                            <option value="50" selected={itemsPerPage === 50}>50</option>
                            <option value="100" selected={itemsPerPage === 100}>100</option>
                        </select>
                    </div>
                </div>



                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="table-responsive tbl-fixed-header tbl-main">
                            <table id="lettertype-table" cellpadding="0" cellspacing="0" class="table table-col-freeze">

                                <thead>
                                    <tr>
                                        <th>Asset name</th>
                                        <th>Asset type</th>
                                        <th>Maker</th>
                                        <th>Image</th>
                                        <th>Serial number</th>
                                        <th>Assigned to</th>
                                        <th>Employee Remark</th>
                                        {userRole !== 7 && (
                                            <th>Assignee history</th>
                                        )}
                                        <th>Status</th>
                                        {[1, 2, 7, 8, 9].includes(userRole) && (
                                            <th class="last-col-freeze">Action</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((asset, index) => (
                                        <tr key={index}>
                                            <td>{asset.asset_name}</td>
                                            <td>{asset.asset_type?.type_name || '-'}</td>
                                            <td>{asset.asset_maker?.maker_name || '-'}</td>
                                            <td>
                                                {asset.media?.[0]?.filepath ? (
                                                    <CarouselImage images={asset.media} />
                                                ) : (
                                                    '-'
                                                )}
                                            </td>

                                            <td>{asset.sr_no}</td>
                                            <td>
                                                {asset?.assigned_to ? (
                                                    <a
                                                        href={`../../employee/profile/${asset.assigned_to.user_id_encrypted}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {[
                                                            asset.assigned_to._FirstName,
                                                            asset.assigned_to._MiddleName,
                                                            asset.assigned_to._LastName
                                                        ]
                                                            .filter(Boolean)
                                                            .join(' ')}{' '}
                                                        ({asset.assigned_to._UserEmployeeID})
                                                    </a>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </td>
                                            <td>{asset?.assigned_to?.asset_assignment_actions?.length > 0 ? asset.assigned_to.asset_assignment_actions[0].remark : '-'}</td>
                                            {userRole !== 7 && (
                                                <td>
                                                    <button title="View Assignee History" className="btn ms-2" onClick={() => setShowModalAssignee(asset._id)}>
                                                        <span
                                                            className="material-icons-outlined">visibility</span>
                                                    </button>
                                                </td>
                                            )}
                                            <td>{asset.status ? 'Active' : 'In-Active'}</td>

                                            {[1, 2, 7, 8, 9].includes(userRole) && (  // admin & employee
                                                <td class="last-col-freeze">
                                                    {/* for employee */}
                                                    {[7].includes(userRole) && !asset?.assignment?.asset_request_id && (  // employee
                                                        <>
                                                            {asset?.assigned_to?.asset_assignment_actions?.length === 0 && (
                                                                <>
                                                                    <button title="Acknowledge" className='btn btn-sm' onClick={() => {
                                                                        setActionData({
                                                                            _id: asset.assignment_id,
                                                                            status: 1,   // Acknowledged by employee
                                                                            remark: ''
                                                                        });
                                                                        setActionTitle('Acknowledge Assignment');
                                                                        setActionDeclaration(declaration);
                                                                        setEnableButton(false);
                                                                    }}>
                                                                        <span
                                                                            className="material-icons-outlined"><FaCheckCircle /></span>
                                                                    </button>
                                                                    {/* <button title="Reject" className='btn btn-sm' onClick={() => {
                                                                        setActionData({
                                                                            _id: asset.assignment_id,
                                                                            status: 2,   // Rejected by employee
                                                                            remark: ''
                                                                        });
                                                                        setActionTitle('Reject Assignment');
                                                                    }}>
                                                                        <span
                                                                            className="material-icons-outlined"><FaTimesCircle /></span>
                                                                    </button> */}
                                                                </>
                                                            )}
                                                            {asset?.assigned_to?.asset_assignment_actions?.[0]?.status === 1 && (
                                                                <span>Acknowledged by Employee</span>
                                                            )}
                                                            {asset?.assigned_to?.asset_assignment_actions?.[0]?.status === 2 && (
                                                                <span>Rejected by Employee</span>
                                                            )}
                                                        </>

                                                    )}



                                                    {/* for admin */}
                                                    {[1, 2, 8, 9].includes(userRole) && (  // admin
                                                        <>
                                                            {asset.status === 1 && (
                                                                <button title="Assign / Return" className='btn btn-sm' onClick={() => {
                                                                    setAssignModalShow(true);
                                                                    setAssignModalForm({
                                                                        asset_id: asset._id,
                                                                        user_id: asset.assigned_to?._UserID || null,
                                                                        remark: '',
                                                                        request_type: asset.assigned_to ? 'Return' : 'New', // return, assign

                                                                    });
                                                                }}>
                                                                    <span
                                                                        className="material-icons-outlined">assignment_turned_in</span>
                                                                </button>
                                                            )}
                                                            <button title="Edit" className='btn btn-sm' onClick={() => setModalData(asset)}>
                                                                <span className="material-icons-outlined">edit</span>
                                                            </button>
                                                            <button title="Delete" className="btn btn-sm" onClick={() => deleteAsset(asset._id)}>
                                                                <span className="material-icons-outlined">delete</span>
                                                            </button>
                                                        </>
                                                    )}
                                                </td>

                                            )}

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {filteredAssets.length === 0 && <p className="text-center">No data found.</p>}
                        </div>
                    </div>
                </div>

                {/* Pagination */}
                {/* <div class="row align-items-center">
                    <div class="col-sm-6 text-start">
                        {
                            totalPages > 1 && (
                                <nav aria-label="Page navigation">
                                    <ul class="pagination">
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <li key={index} className={`${currentPage === index + 1 ? 'active' : ''}`}>
                                                <button className="btn btn-sm" onClick={() => paginate(index + 1)}>{index + 1}</button>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            )
                        }
                    </div>
                    <div class="col-sm-6 text-end">
                        Showing {filteredAssets.length > indexOfFirstItem ? indexOfFirstItem + 1 : 0} to {filteredAssets.length > indexOfLastItem ? indexOfLastItem : filteredAssets.length} of {filteredAssets.length} ({totalPages} Pages)
                    </div>
                </div> */}
                <div className="row align-items-center">
                    <div className="col-sm-6 text-start">
                        {totalPages > 1 && (
                            <nav aria-label="Page navigation">
                                <ul className="pagination">

                                    {/* First */}
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link btn btn-sm" onClick={() => paginate(1)}>
                                            ≪
                                        </button>
                                    </li>

                                    {/* Previous */}
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link btn btn-sm" onClick={() => paginate(currentPage - 1)}>
                                            ‹
                                        </button>
                                    </li>

                                    {/* Limited Page Numbers */}
                                    {(() => {
                                        const pageNumbers = [];
                                        const maxVisible = 3; // Show only 3 pages at a time
                                        let start = Math.max(1, currentPage - 1);
                                        let end = Math.min(totalPages, start + maxVisible - 1);

                                        if (end - start < maxVisible - 1) {
                                            start = Math.max(1, end - maxVisible + 1);
                                        }

                                        for (let i = start; i <= end; i++) {
                                            pageNumbers.push(
                                                <li
                                                    key={i}
                                                    className={`page-item ${currentPage === i ? "active" : ""}`}
                                                >
                                                    <button className="page-link btn btn-sm" onClick={() => paginate(i)}>
                                                        {i}
                                                    </button>
                                                </li>
                                            );
                                        }

                                        return pageNumbers;
                                    })()}

                                    {/* Next */}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link btn btn-sm" onClick={() => paginate(currentPage + 1)}>
                                            ›
                                        </button>
                                    </li>

                                    {/* Last */}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link btn btn-sm" onClick={() => paginate(totalPages)}>
                                            ≫
                                        </button>
                                    </li>

                                </ul>
                            </nav>
                        )}
                    </div>

                    <div className="col-sm-6 text-end">
                        Showing {filteredAssets.length > indexOfFirstItem ? indexOfFirstItem + 1 : 0}
                        {" "}to{" "}
                        {filteredAssets.length > indexOfLastItem ? indexOfLastItem : filteredAssets.length}
                        {" "}of {filteredAssets.length} ({totalPages} Pages)
                    </div>
                </div>


            </div>
        </div >
    );
}

export default AssetTab;